"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = void 0;
var comment_component_1 = require("./comment.component");
Object.defineProperty(exports, "Comment", { enumerable: true, get: function () { return comment_component_1.Comment; } });
